import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSession } from '../hooks/useSession';
import { useActiveGame } from '../hooks/useActiveGame';
import { getSocket } from '../lib/socket';
import { setPendingJoin } from '../lib/pendingJoin';
import { AppShell } from '../components/AppShell';

export default function JoinRedirectPage() {
  const { code } = useParams<{ code: string }>();
  const nav = useNavigate();
  const user = useSession(s => s.user);
  const refreshActive = useActiveGame(s => s.refresh);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      // remember code so we can join after login (guest or OAuth)
      if (code) setPendingJoin(code);
      nav('/login', { replace: true });
      return;
    }
    if (!code) return;
    const sock = getSocket();
    sock.emit('game:join', { code }, (res) => {
      if (res.ok) { refreshActive(); nav(`/game/${res.data.gameId}`, { replace: true }); }
      else setErr(res.error);
    });
  }, [user, code, nav, refreshActive]);

  return (
    <AppShell>
      <div className="panel p-8 text-center space-y-2">
        <div className="animate-pulse text-ink-200">Joining game {code}…</div>
        {err && <div className="text-rose-400">{err}</div>}
      </div>
    </AppShell>
  );
}
